import { render } from "./LogoLight.vue?vue&type=template&id=150bbb64&scoped=true"
import script from "./LogoLight.vue?vue&type=script&lang=js"
export * from "./LogoLight.vue?vue&type=script&lang=js"

import "./LogoLight.vue?vue&type=style&index=0&id=150bbb64&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150bbb64"]])

export default __exports__